<template>
<!-- 跳转到规范页面显示的内容如下：
图片上传规范【H2标题】
为保证您上传的模型能够被正确展现，提升上传资产的浏览量，我们建议您在制作预览图时按照如下要求进行：
1. 第一张预览图默认作为资产的封面进行显示，要求比例为1:1的正方形图片，格式要求为jpg/png，宽高不低于800px。
2. 推荐上传预览图最少为五张，多视图以及线框图，多精美图会增加销售量。
3. 不得上传与模型资产无关或违法图片，否则不予通过。
4. 建议单张图片大小不高于10M，否则可能会影响用户浏览体验。
5. 请严格遵守国家相关法规，不上传违法内容。 -->
  <div>
    <div class="protocol-box">
      <h1>图片上传规范</h1>
      <div class="entry-content">
        <p>
          为保证您上传的模型能够被正确展现，提升上传资产的浏览量，我们建议您在制作预览图时按照如下要求进行：
        </p>

        <p>
          一、第一张预览图默认作为资产的封面进行显示，要求比例为1:1的正方形图片，格式要求为jpg/png，宽高不低于800px。
        </p>

        <p>
          二、推荐上传预览图最少为五张，多视图以及线框图，多精美图会增加销售量。
        </p>

        <p>
          三、不得上传与模型资产无关或违法图片，否则不予通过。
        </p>

        <p>
          四、建议单张图片大小不高于10M，否则可能会影响用户浏览体验。
        </p>

        <p>
          五、请严格遵守国家相关法规，不上传违法内容。
        </p>

        <!-- <p>欢迎来到CG世界知识库</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less" scoped>
.protocol-box {
  padding: 30px;
  width: 1000px;
  margin: 0 auto 50px;
  color: #121212;
  background: #ffffff;
  h1 {
    font-size: 26px;
    font-weight: 600;
    line-height: 36px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f6f7;
    padding-bottom: 20px;
  }
  p {
    word-wrap: break-word;
    word-break: normal;
    line-height: 1.8;
    margin-bottom: 1.7em;
  }
}
</style>
